import { render, staticRenderFns } from "./register_form.vue?vue&type=template&id=53c43c97&scoped=true&"
import script from "./register_form.vue?vue&type=script&lang=js&"
export * from "./register_form.vue?vue&type=script&lang=js&"
import style0 from "./register_form.vue?vue&type=style&index=0&id=53c43c97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c43c97",
  null
  
)

export default component.exports